<div *ngIf="!validRecoveryToken && tokenVerificationComplete">
  <h1 class="harp-card-title">User Not Found</h1>
  <p>The requested user for full account recovery was not found.</p>
  <a [routerLink]="['/login']" queryParamsHandling="merge"
    ><strong class="icon ion-md-arrow-round-back"></strong> Back to Login</a
  >
</div>
<div *ngIf="validRecoveryToken">
  <div *ngIf="!isChallengeQuestionReset">
    <h1 class="harp-card-title">Reset Challenge Question</h1>
    <p>Enter the fields below to reset your challenge question.</p>
    <p>
      All fields marked with an asterisk (<span class="required">*</span>) are
      required.
    </p>

    <form [formGroup]="resetChallengeQuestionForm" (ngSubmit)="onSetRecovery()">
      <harp-input [inputConfig]="challengeQuestionInputConfig"></harp-input>
      <harp-input
        [inputConfig]="challengeQuestionAnswerInputConfig"
      ></harp-input>

      <button
        type="submit"
        class="btn btn-primary btn-lg"
        [disabled]="resetChallengeQuestionForm.invalid"
      >
        Reset Challenge Question
      </button>
    </form>
  </div>

  <div *ngIf="isChallengeQuestionReset">
    <h1 class="harp-card-title">Success!</h1>
    <p>
      Your challenge question has been successfully reset. You should receive an
      email shortly containing a temporary password.
    </p>
    <a [routerLink]="['/login']" queryParamsHandling="merge"
      ><strong class="icon ion-md-arrow-round-back"></strong> Back to Login</a
    >
  </div>
</div>
